import { createSelector } from '@ngrx/store';
import { getAuthState } from './feature.selector';
import { AuthState } from '../auth.state';

export const selectOrgState = createSelector(getAuthState, (state: AuthState) => state.organization);
export const selectSearchedOrganizationsState = createSelector(getAuthState, (state: AuthState) => state.searchedOrganizations);
